"use strict";

(function () {

  var options = null;
  var disclaimer = null;
  var cookie = null;

  /**
   * options:
   * cookieName: Name of the cookie to use (default: cookie_clicked)
   * closeButton: Text for the closeButton. Also takes an object like {de: "German closeButton", en: "English closeButton"}  (default: "X")
   * text: Disclaimer text as html. Also takes an object like {de: "German text", en: "English text"} (default: "")
   * fallbackLanguage: language to use if text or closeButton is object and the display language is not defined. (default: "default")
   * cookieLiveTime: how much time should pass before the disclaimer is shown again? As int in seconds (default: 31 days)
   * wrapperClass: class name to use for the wrapper (default: "cookie-disclaimer")
   * textClass: class name to use for the text (default: "cookie-disclaimer__text")
   * buttonClass: class name to use for the button (default: "cookie-disclaimer__button")
   */
  window.CookieDisclaimer = function() {
    const defaults = {
      cookieName: "cookie_clicked",
      closeButton: 'X',
      fallbackLanguage: "default",
      text: "",
      cookieLiveTime: 31 * 24 * 3600,
      wrapperClass: "cookie-disclaimer",
      textClass: "cookie-disclaimer__text",
      buttonClass: "cookie-disclaimer__button"
    };

    if(arguments[0]  && typeof arguments[0] === "object") {
      options = extendDefaults(defaults, arguments[0]);
    }
    else {
      options = defaults;
    }

    cookie = options.cookieName + "=true";
  };

  CookieDisclaimer.prototype.display = function(language) {
    if (!isCookieSet() && cookieEnabled()) {
      var text = options.text;
      var closeButton = options.closeButton;
      if(language && typeof options.text === "object") {
        text = options.text[language];
      }
      if (typeof text === "object" || typeof text === "undefined") {
        text = options.text[options.fallbackLanguage]
      }
      if(language && typeof options.closeButton === "object") {
        closeButton = options.closeButton[language]
      }
      if (typeof closeButton === "object" || typeof closeButton === "undefined") {
        closeButton = options.closeButton[options.fallbackLanguage]
      }
      createDisclaimer(text, closeButton);
    }
  }

  // Utility method to extend defaults with user options
  function extendDefaults(source, properties) {
    var property;
    for (property in properties) {
      if (properties.hasOwnProperty(property)) {
        source[property] = properties[property];
      }
    }
    return source;
  }

  function createDisclaimer(text, closeButton) {
    disclaimer = document.createElement("div");
    disclaimer.setAttribute("class", options.wrapperClass);
    var cookie_text = document.createElement("div");
    cookie_text.setAttribute("class", options.textClass);
    cookie_text.innerHTML = text;
    var cookie_close = document.createElement('a');
    cookie_close.setAttribute("class", options.buttonClass);
    cookie_close.appendChild(document.createTextNode(closeButton));
    cookie_close.addEventListener('click', function (ev) {
      ev.preventDefault();
      removeDisclaimer();
    });
    disclaimer.appendChild(cookie_text);
    disclaimer.appendChild(cookie_close);
    document.getElementsByTagName('body')[0].appendChild(disclaimer);
  };

  function removeDisclaimer() {
    setCookie();
    document.getElementsByTagName('body')[0].removeChild(disclaimer);
  }

  function isCookieSet() {
    return document.cookie.indexOf(cookie) > -1;
  }

  function setCookie() {
    var exp = new Date();
    var time = exp.getTime() + (options.cookieLiveTime * 1000);
    exp.setTime(time);
    document.cookie = cookie + "; path=/; expires=" + exp.toUTCString() + "; max-age=" + options.cookieLiveTime;
  }

  function cookieEnabled() {
    var cookieEnabled = navigator.cookieEnabled;
    if(!cookieEnabled) {
      document.cookie = "testcookie";
      cookieEnabled = document.cookie.indexOf("testcookie") != -1;
      document.cookie = "testcookie=;expires=Thu, 01 Jan 1970 00:00:01 GMT";
    }
    return cookieEnabled;
  }
}());



// WEBPACK FOOTER //
// ./src/assets/vendor/cookie-disclaimer/cookie-disclaimer.js